(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["crack-product-carousel"] && !Shopify.designMode) return;
  try {
    
  class CrackProductCarousel {
    constructor(element) {
      this.element = element;
      this.viewport = element.querySelector('[data-crack-carousel-viewport]');
      this.track = element.querySelector('[data-crack-carousel-track]');
      this.cards = Array.from(element.querySelectorAll('[data-crack-carousel-card]'));
      this.previous = element.querySelector('[data-crack-carousel-previous]');
      this.next = element.querySelector('[data-crack-carousel-next]');
      this.dots = element.querySelector('[data-crack-carousel-dots]');
      this.index = 0;
      this.timer = null;
      this.drag = null;
      this.suppressClick = false;
      this.touchLayout = window.matchMedia('(max-width: 989px)');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.bind();
      this.render();
      this.start();
    }

    get visibleCards() {
      return Math.max(1, Math.round(this.viewport.clientWidth / this.cards[0].getBoundingClientRect().width));
    }

    get totalPages() {
      return Math.max(1, this.cards.length - this.visibleCards + 1);
    }

    get cardStride() {
      const cardWidth = this.cards[0].getBoundingClientRect().width;
      const gap = Number.parseFloat(getComputedStyle(this.track).gap) || 0;
      return cardWidth + gap;
    }

    bind() {
      this.previous.addEventListener('click', () => this.move(-1));
      this.next.addEventListener('click', () => this.move(1));
      this.element.addEventListener('mouseenter', () => this.stop());
      this.element.addEventListener('mouseleave', () => this.start());
      this.element.addEventListener('focusin', () => this.stop());
      this.element.addEventListener('focusout', () => this.start());
      this.viewport.addEventListener('pointerdown', (event) => this.handlePointerDown(event));
      this.viewport.addEventListener('pointermove', (event) => this.handlePointerMove(event));
      this.viewport.addEventListener('pointerup', (event) => this.handlePointerEnd(event));
      this.viewport.addEventListener('pointercancel', (event) => this.handlePointerEnd(event));
      this.viewport.addEventListener('click', (event) => this.handleClick(event), true);
      window.addEventListener('resize', () => this.render());
    }

    handlePointerDown(event) {
      if (!this.touchLayout.matches || !event.isPrimary || (event.pointerType === 'mouse' && event.button !== 0)) return;
      this.stop();
      this.drag = {
        pointerId: event.pointerId,
        startX: event.clientX,
        startOffset: this.index * this.cardStride,
        moved: false
      };
      this.viewport.setPointerCapture?.(event.pointerId);
    }

    handlePointerMove(event) {
      if (!this.drag || event.pointerId !== this.drag.pointerId) return;
      const distance = event.clientX - this.drag.startX;
      if (Math.abs(distance) < 4) return;
      this.drag.moved = true;
      this.viewport.dataset.crackCarouselDragging = 'true';
      const maxOffset = (this.totalPages - 1) * this.cardStride;
      const nextOffset = Math.min(maxOffset, Math.max(0, this.drag.startOffset - distance));
      this.track.style.transform = `translateX(-${nextOffset}px)`;
      event.preventDefault();
    }

    handlePointerEnd(event) {
      if (!this.drag || event.pointerId !== this.drag.pointerId) return;
      const drag = this.drag;
      this.drag = null;
      this.viewport.removeAttribute('data-crack-carousel-dragging');
      this.viewport.releasePointerCapture?.(event.pointerId);

      if (drag.moved) {
        this.suppressClick = true;
        const distance = event.clientX - drag.startX;
        if (Math.abs(distance) >= 42) {
          this.move(distance < 0 ? 1 : -1);
        } else {
          this.render();
        }
        window.setTimeout(() => {
          this.suppressClick = false;
        }, 0);
      }

      this.start();
    }

    handleClick(event) {
      if (!this.suppressClick) return;
      event.preventDefault();
      event.stopPropagation();
    }

    move(direction) {
      this.index = (this.index + direction + this.totalPages) % this.totalPages;
      this.render();
    }

    render() {
      if (!this.cards.length) return;
      this.index = Math.min(this.index, this.totalPages - 1);
      this.track.style.transform = `translateX(-${this.index * this.cardStride}px)`;
      this.dots.innerHTML = '';
      for (let page = 0; page < this.totalPages; page += 1) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = `crack-product-carousel__dot${page === this.index ? ' is-active' : ''}`;
        dot.addEventListener('click', () => { this.index = page; this.render(); });
        this.dots.append(dot);
      }
    }

    start() {
      if (this.element.dataset.autoplay !== 'true' || this.reducedMotion || this.cards.length < 2) return;
      this.stop();
      this.timer = window.setInterval(() => this.move(1), Number(this.element.dataset.speed) * 1000);
    }

    stop() {
      if (this.timer) window.clearInterval(this.timer);
      this.timer = null;
    }
  }

  document.querySelectorAll('[data-crack-product-carousel]').forEach((element) => new CrackProductCarousel(element));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["workshop-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('workshop-product')) {
    class WorkshopProduct extends HTMLElement {
      connectedCallback() {
        this.classList.add('workshop-product--enhanced');
        this.handleInvalid = this.handleInvalid.bind(this);
        this.handleFieldInput = this.handleFieldInput.bind(this);
        this.handleVariantChange = this.handleVariantChange.bind(this);
        this.handleLightboxClick = this.handleLightboxClick.bind(this);
        this.handleLightboxClose = this.handleLightboxClose.bind(this);

        this.addEventListener('invalid', this.handleInvalid, true);
        this.addEventListener('input', this.handleFieldInput, true);

        this.variantSelect = this.querySelector('[data-workshop-variant-select]');
        this.variantInput = this.querySelector('[ref="variantId"]');
        this.currentPrice = this.querySelector('[data-workshop-current-price]');
        this.comparePrice = this.querySelector('[data-workshop-compare-price]');
        this.addToCartButton = this.querySelector('[ref="addToCartButton"]');
        this.addToCartText = this.addToCartButton?.querySelector('.add-to-cart-text__content span span');
        this.lightbox = this.querySelector('[data-workshop-lightbox]');
        this.lightboxImage = this.querySelector('[data-workshop-lightbox-image]');

        this.variantSelect?.addEventListener('change', this.handleVariantChange);
        this.addEventListener('click', this.handleLightboxClick);
        this.lightbox?.addEventListener('close', this.handleLightboxClose);
        this.revealSections();
      }

      disconnectedCallback() {
        this.removeEventListener('invalid', this.handleInvalid, true);
        this.removeEventListener('input', this.handleFieldInput, true);
        this.removeEventListener('click', this.handleLightboxClick);
        this.variantSelect?.removeEventListener('change', this.handleVariantChange);
        this.lightbox?.removeEventListener('close', this.handleLightboxClose);
        this.observer?.disconnect();
      }

      handleLightboxClick(event) {
        const target = event.target;
        if (!(target instanceof Element)) return;

        const trigger = target.closest('[data-workshop-lightbox-trigger]');
        if (trigger && this.contains(trigger)) {
          const source = trigger.dataset.workshopLightboxSrc;
          if (!source || !this.lightbox || !this.lightboxImage) return;

          event.preventDefault();
          this.lightboxImage.src = source;
          this.lightboxImage.alt = trigger.dataset.workshopLightboxAlt || '';
          if (typeof this.lightbox.showModal === 'function') {
            this.lightbox.showModal();
          } else {
            this.lightbox.setAttribute('open', '');
          }
          return;
        }

        if (!this.lightbox?.open) return;
        if (target === this.lightbox || target.closest('[data-workshop-lightbox-close]')) {
          if (typeof this.lightbox.close === 'function') {
            this.lightbox.close();
          } else {
            this.lightbox.removeAttribute('open');
            this.handleLightboxClose();
          }
        }
      }

      handleLightboxClose() {
        if (!this.lightboxImage) return;
        this.lightboxImage.removeAttribute('src');
        this.lightboxImage.alt = '';
      }

      handleInvalid(event) {
        const field = event.target;
        if (!(field instanceof HTMLInputElement) || !field.matches('[data-workshop-required]')) return;

        event.preventDefault();
        field.setAttribute('aria-invalid', 'true');
        const errorId = field.getAttribute('aria-errormessage');
        const errorMessage = errorId ? this.querySelector(`#${errorId}`) : null;
        if (errorMessage) {
          errorMessage.textContent = field.dataset.workshopError || field.validationMessage;
          errorMessage.hidden = false;
        }
      }

      handleFieldInput(event) {
        const field = event.target;
        if (!(field instanceof HTMLInputElement) || !field.matches('[data-workshop-required]')) return;
        if (!field.validity.valid) return;

        field.removeAttribute('aria-invalid');
        const errorId = field.getAttribute('aria-errormessage');
        const errorMessage = errorId ? this.querySelector(`#${errorId}`) : null;
        if (errorMessage) errorMessage.hidden = true;
      }

      handleVariantChange(event) {
        const option = event.target.selectedOptions[0];
        if (!option || !this.variantInput) return;

        this.variantInput.value = option.value;
        if (this.currentPrice) this.currentPrice.textContent = option.dataset.price || '';

        const comparePrice = option.dataset.compareAtPrice || '';
        if (this.comparePrice) {
          this.comparePrice.textContent = comparePrice;
          this.comparePrice.hidden = !comparePrice || comparePrice === option.dataset.price;
        }

        const isAvailable = option.dataset.available === 'true';
        if (this.addToCartButton) this.addToCartButton.disabled = !isAvailable;
        if (this.addToCartText) {
          this.addToCartText.textContent = isAvailable
            ? this.dataset.reserveLabel || ''
            : this.dataset.soldOutLabel || this.dataset.unavailableLabel || '';
        }
      }

      revealSections() {
        const sections = this.querySelectorAll('.workshop-product__reveal');
        if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          sections.forEach((section) => section.classList.add('is-visible'));
          return;
        }

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-visible');
              this.observer.unobserve(entry.target);
            });
          },
          { threshold: 0.12 }
        );
        sections.forEach((section) => this.observer.observe(section));
      }
    }

    customElements.define('workshop-product', WorkshopProduct);
  }

  } catch(e) { console.error(e); }
})();
})();
